import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';

interface LeadershipExperienceProps {
  formik: any;
}

export default function LeadershipExperience({formik}: LeadershipExperienceProps) {
  const {t} = useTranslation();

  const getHoverBackgroundColor = () => {
    return orangeColors[4];
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        mb: 5,
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
        }}
      >
        <Box
          sx={{
            borderRadius: '16px',
            backgroundColor:
              formik.values.applicantOnboarding.qualifications.leadershipExperience === true
                ? getHoverBackgroundColor()
                : 'background.default',
            p: 2,
            width: '100%',
            textAlign: 'center',
            '&:hover': {
              backgroundColor: getHoverBackgroundColor(),
              cursor: 'pointer',
            },
          }}
          onClick={() => {
            formik.setFieldValue('applicantOnboarding.qualifications.leadershipExperience', true);
          }}
        >
          <Typography variant='h6'>{t('shared.yes')}</Typography>
        </Box>
        <Box
          sx={{
            borderRadius: '16px',
            backgroundColor:
              formik.values.applicantOnboarding.qualifications.leadershipExperience === true
                ? 'background.default'
                : getHoverBackgroundColor(),
            p: 2,
            width: '100%',
            textAlign: 'center',
            '&:hover': {
              backgroundColor: getHoverBackgroundColor(),
              cursor: 'pointer',
            },
          }}
          onClick={() => {
            formik.setFieldValue('applicantOnboarding.qualifications.leadershipExperience', false);
          }}
        >
          <Typography variant='h6'>{t('shared.no')}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
